module.exports = __webpack_public_path__ + "static/media/closeAddDiver.40fa0c3e.svg";